import fallbackShowImage from '../assets/images/e-logo-600-min.png';

export const LEGACY_WORDPRESS_IMAGE =
  'https://www.eruptionradio.uk/site/wp-content/uploads/2024/01/logomain.png';

export const resolveFallbackImage = (envValue?: string | null): string => {
  const trimmed = envValue?.trim();
  if (trimmed && trimmed !== LEGACY_WORDPRESS_IMAGE) {
    return trimmed;
  }
  return fallbackShowImage;
};

export const DEFAULT_SHOW_FALLBACK_IMAGE = resolveFallbackImage(
  process.env.REACT_APP_DEFAULT_SHOW_IMAGE
);
